
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "34",
    "height": "34",
    "viewBox": "0 0 34 34"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "id": "share",
        "class": "cls-1",
        "d": "M210,607h-9v-6h4l-5-6-5,6h4v6h-9a2,2,0,0,1-2-2V593a2,2,0,0,1,2-2h20a2,2,0,0,1,2,2v12A2,2,0,0,1,210,607Zm-14,2h8a1,1,0,0,1,0,2h-8A1,1,0,0,1,196,609Z",
        "transform": "translate(-183 -584)"
      }
    }
  ]
})
    }
  